import * as types from '../../types';
import { logInternalError } from '../errors';
import { webApiClient } from './apiUtils';

interface GetRemoteConfigOptions {
  upgradeFlow?: boolean;
  anonymousId?: string;
  countryCode?: string;
  language?: string;
}

export async function getRemoteConfig({
  upgradeFlow,
  anonymousId,
  countryCode,
  language,
}: GetRemoteConfigOptions = {}): Promise<types.RemoteConfig> {
  try {
    const response = await webApiClient.get<types.RemoteConfig>('/api/ecommerce/products', {
      params: {
        ...(upgradeFlow ? { upgradeFlow: 'true' } : {}),
        ...(anonymousId ? { anonymousId } : {}),
        ...(countryCode ? { countryCode } : {}),
        ...(language ? { language } : {}),
      },
    });

    const products = response.data.products;
    if (!products || products.length < 1) {
      throw new Error('No products found');
    }

    return response.data;
  } catch (error) {
    logInternalError(error, {
      fingerprint: ['{{ default }}', error.message],
      tags: {
        checkoutStep: 'fetchProducts',
      },
    });
    throw new Error('Unable to load products');
  }
}
